import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Addschedulebox from './Orderfunction';
import Table from '@mui/material/Table';
import HistoryIcon from '@mui/icons-material/History';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import AddCardIcon from '@mui/icons-material/AddCard';
import Collapse from '@mui/material/Collapse';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
const headCells = [
  
  { id: 'classtype', numeric: false, label: 'Package Type' },
   { id: 'cnt', numeric: false, label: 'Total No.' },
  { id: 'or_totalamount', numeric: false, label: 'Revenue' },
   
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
 export default class OrderManage extends Component {

   constructor(props) {
      super(props);
	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
            this.state = {orderdata:[],page: 0,subid:'', prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[], order:'desc' ,orderBy:'',names:'', redirect:false,pagename:'',invoicedate:dayjs(Date.now()),invoicedate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),classtype:'',type:'',orid:'',Branchdata:[],branchid:'',invoicetodate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),invoicetodate:dayjs(Date.now()),exportdata:[],tabcontent:[]}
			this.updateDonenewParent = this.updateDonenewParent;
   }
      
   updateDonenewParent = (text) => {    }
   myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val},()=>{ 
  if(nam==="classtype")
 {this.setState({oractive: ''});
	
 }}); 

} 
	  


	componentWillMount  () {
	

	
	document.title = "AthaYog Living - Order Management";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	
	this.onloadBranch();
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apiOrdercall(this.state.page,this.state.rowsPerPage);
  this.apiExportOrdercall();
} 		
 onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall&sorting=bm_id')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid=this.state.branchid;

								if(resp.data.length===1 && strbrid!='')
								{
									strbrid=resp.data[0]["bm_id"];
								}
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
		
        this.setState({branchid:strbrid,
          Branchdata: [{value: '0', display:'Select Branch'}].concat(BranchFromApi)
        });
								
							})


							
  }else{
	  this.setState({Branchdata:[]});
  }
  
  });
	
} 
  
apiOrdercall(page,rowsPerPage){
	let strbranch=this.state.branchid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 }
	 axios.get(Serverurl+'ajaxorders.php?action=accountsrprt&StartIndex='+page+'&PageSize='+rowsPerPage+'&or_invoicedate='+this.state.invoicedate1+'&or_invoicetodate='+this.state.invoicetodate1+'&or_bm_id='+strbranch+'&or_classtype='+this.state.classtype)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){

		console.log(resp.data)	
			var strorderarr=resp.data,prevclass="",classtotal=0;
let transformed = []


   strorderarr.map(item => {
        let exist = transformed.find(t => t.classtype == item.classtype)
        if(exist) {
           exist.total =  parseFloat(exist.total) +parseFloat(item.total)
		}
        else{ 
            transformed.push({ ...item })
		}
    })
	 console.log(resp.data)		
this.setState({  
			  orderdata: resp.data, tabcontent :transformed,
			  //tabcontent :resp.data,
			   totaldata:parseInt(resp.data[0].count)
			   

		    });
		
     }
	 else{
		   this.setState({orderdata:[],totaldata:0});
	 }

    });
}
 
apiExportOrdercall(){
	let strbranch=this.state.branchid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 }
	 axios.get(Serverurl+'ajaxorders.php?action=accountsrprt&or_invoicedate='+this.state.invoicedate1+'&or_invoicetodate='+this.state.invoicetodate1+'&or_bm_id='+strbranch+'&or_classtype='+this.state.classtype)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){

			this.setState({  
			  exportdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count)
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({exportdata:[],totaldata:0});
	 }

    });
}

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apiOrdercall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   

  handleClickSearch=()=>{  
  
  this.apiOrdercall(this.state.page,this.state.rowsPerPage);
this.apiExportOrdercall();
  } 
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apiOrdercall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};	  
	  
handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ invoicedate:dayjs(date),
invoicedate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
invoicetodate: todate1,
invoicetodate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ invoicetodate:dayjs(date),
invoicetodate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
  
  
  
  
render() { 


  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  
 let prev="",gst=0,total=0,subtotal=0,extramt=0;
  
  return (
  

<React.Fragment>
<div className="boxheading">
				
<h2> Account Report </h2>
</div>
<div className="clear"></div>

 <div className="searchmaster">


  
  <ul>
  {localStorage.getItem("AYLrole")==="1" && (
  <li>
<p>Select Branch</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			className="txtbox"
			native
			value={this.state.branchid}
			onChange={this.myChangeHandler}
			name='branchid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
  )}
 
		  <li><p>Class Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" inputProps={{tabIndex: "2"}}
		  className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.classtype}
		  name="classtype"
		
        >
	
	<option value="">Select Your Type</option>
                  <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in studio</option>
 <option value={3}>Group</option>
 <option value={4}>Prenatal</option> <option value={5}>Products</option>
 <option value={6}>Personal Training Online</option>
 <option value={7}>TTC</option>
        </Select>

		</FormControl>
		</p>
	</li>
 
		
 <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicedate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicetodate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>

 		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  
	  <ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="leadmasterreport"
							filename="Accounts Report"
							sheet="Accounts Report"
							buttonText="EXPORT"/></p></li> 
		
		
		
		
		</ul>
		
</div>

<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.orderdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.orderdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => { 
gst=parseFloat(gst)+parseFloat(item.gstamount);
total=parseFloat(total)+parseFloat(item.total);	
{/*subtotal=parseFloat(subtotal)+parseFloat(item.subtotalamount);*/}
subtotal=parseFloat(subtotal)+parseFloat(item.or_totalamount);
{/*extramt += parseFloat(item.or_extramt || 0);*/}



	
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.classtype}-{item.sb_title}</TableCell>
<TableCell>{item.cnt}</TableCell>
	{/*<TableCell align="right" >Rs.{item.subtotalamount}</TableCell>*/}
	<TableCell align="right">Rs.{parseFloat(item.or_totalamount).toFixed(2)}</TableCell>



 </TableRow>

 </React.Fragment>	
);
					})}
					{this.state.totaldata!==0 &&(
					 <React.Fragment>
					<TableRow key={0} >
<TableCell align="right" colspan="2">Revenue</TableCell>
<TableCell align="right" >Rs.{(subtotal).toFixed(2)}</TableCell>
					</TableRow>
					{/*<TableRow>
  <TableCell align="right" colSpan={2}>Additional Amount</TableCell>
  <TableCell align="right">Rs.{extramt.toFixed(2)}</TableCell>
					</TableRow>*/}
					<TableRow key={0} >
<TableCell align="right" colspan="2">GST</TableCell>
<TableCell align="right" >{(gst).toFixed(2)}</TableCell>
					</TableRow>
					<TableRow key={0} >
<TableCell align="right" colspan="2">Total</TableCell>
<TableCell align="right" >Rs.{(total).toFixed(2)}</TableCell>
					</TableRow></React.Fragment>
					) }
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="10">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
    
  </Paper>
<div className="summaryreport"><h2>Summary</h2>
<table width="70%" cellpadding='10' cellspacing='1'><tr><th align="left">Package Type</th><th>Revenue</th></tr>
  {this.state.tabcontent.map((rows,i)=>{
	 
	   return (
  <tr><td>{rows.classtype}</td><td>Rs.{parseFloat(rows.total).toFixed(2)}</td></tr> 
  )
  })}
  </table></div>
  
<div style={{"display":"none"}}>
  <Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="leadmasterreport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.orderdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.orderdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => { 
			
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.classtype}-{item.sb_title}</TableCell>
<TableCell>{item.cnt}</TableCell>
<TableCell align="right" >{item.or_totalamount}</TableCell>





 </TableRow>

 </React.Fragment>	
);
					})}
					{this.state.totaldata!==0 &&(
					 <React.Fragment>
					<TableRow key={0} >
<TableCell align="right" colspan="2">Revenue</TableCell>
<TableCell align="right" >{(subtotal).toFixed(2)}</TableCell>
					</TableRow>
					
					<TableRow key={0} >
<TableCell align="right" colspan="2">GST</TableCell>
<TableCell align="right" >{(gst).toFixed(2)}</TableCell>
					</TableRow>
					<TableRow key={0} >
<TableCell align="right" colspan="2">Total</TableCell>
<TableCell align="right" >{(total).toFixed(2)}</TableCell>
					</TableRow> </React.Fragment>
					) }
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="10">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  
  </Paper></div>
</React.Fragment>
  );
  }
 }
	  
	